async function createDraftOrderAndRedirectToWhatsApp() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    if (!cart.items || cart.items.length === 0) {
      throw new Error('Cart is empty');
    }

    let customerName = 'Guest Customer';
    let customerEmail = '';
    let customerPhone = '';
    let customerCompany = '';
    let customerNIF = '';
    let customerAddress = '';

    const customerInfo = window.shopifyCustomer || null;

    if (customerInfo && customerInfo.isLoggedIn) {
      if (customerInfo.firstName && customerInfo.lastName) {
        customerName = `${customerInfo.firstName} ${customerInfo.lastName}`;
      }
      if (customerInfo.email) customerEmail = customerInfo.email;
      if (customerInfo.phone) customerPhone = customerInfo.phone;
      if (customerInfo.defaultAddress) {
        const addr = customerInfo.defaultAddress;
        const addressParts = [];
        if (addr.address1) addressParts.push(addr.address1.trim());
        if (addr.city) addressParts.push(addr.city.trim());
        if (addr.zip) addressParts.push(addr.zip.trim());
        if (addr.country) addressParts.push(addr.country.trim());
        if (addressParts.length > 0) customerAddress = addressParts.join(', ');
        if (addr.company) customerCompany = addr.company.trim();
        if (addr.address2) customerNIF = addr.address2.trim();
      }
    }

    const orderNumber = `WA${Date.now()}`;

    const cartAttributes = {
      'customer_name': customerName,
      'customer_email': customerEmail,
      'customer_phone': customerPhone,
      'customer_company': customerCompany,
      'customer_nif': customerNIF,
      'customer_address': customerAddress,
      'whatsapp_order': 'true',
      'whatsapp_order_number': orderNumber,
      'checkout_method': 'whatsapp'
    };

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: cartAttributes })
    });

    window.location.href = '/checkout';

  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

function whatsappCheckout() {
  const button = document.getElementById('whatsapp-checkout');
  handleWhatsAppCheckout(button, null);
}

function whatsappCheckoutDrawer() {
  const button = document.getElementById('CartDrawer-WhatsApp');
  handleWhatsAppCheckout(button, () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.close) cartDrawer.close();
  });
}

function whatsappCheckoutNotification() {
  const button = document.getElementById('cart-notification-whatsapp');
  handleWhatsAppCheckout(button, () => {
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && cartNotification.close) cartNotification.close();
  });
}

async function handleWhatsAppCheckout(button, successCallback) {
  if (!button) return;

  const originalText = button.innerHTML;
  button.innerHTML = 'Processing...';
  button.disabled = true;

  try {
    await createDraftOrderAndRedirectToWhatsApp();
    if (successCallback) successCallback();
  } catch (error) {
    console.error('WhatsApp checkout error:', error);
    button.innerHTML = originalText;
    button.disabled = false;
    const errorDiv = document.getElementById('cart-errors');
    if (errorDiv) {
      errorDiv.innerHTML = '<p style="color: red;">Error processing order. Please try again.</p>';
      setTimeout(() => { errorDiv.innerHTML = ''; }, 5000);
    } else {
      alert('Error processing order. Please try again.');
    }
  }
}

async function checkoutWithWhatsAppNotify() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    if (!cart.items || cart.items.length === 0) {
      window.location.href = '/checkout';
      return;
    }
    window.location.href = '/checkout';
  } catch (error) {
    console.error('Error:', error);
    window.location.href = '/checkout';
  }
}

window.checkoutWithWhatsAppNotify = checkoutWithWhatsAppNotify;
window.whatsappCheckout = whatsappCheckout;
window.whatsappCheckoutDrawer = whatsappCheckoutDrawer;
window.whatsappCheckoutNotification = whatsappCheckoutNotification;
window.createDraftOrderAndRedirectToWhatsApp = createDraftOrderAndRedirectToWhatsApp;
